import * as moment from 'moment';

export interface IMenuModel {
  id: number;
  name: string;
  module: number;
  is_enabled: boolean;
  is_visible: boolean;
  name_translate: string;
  description_translate: string;
  order_visible: number;
  created: moment.Moment;
  modified: moment.Moment;
}

export interface IOptionModel {
  id: number;
  name: string;
  page: {
    id: number;
    name: string;
    code: string;
    description: string;
    is_enabled: boolean;
    created: moment.Moment;
    modified: moment.Moment;
  };
  is_enabled: boolean;
  is_visible: boolean;
  link: string;
  icon: string;
  title: string;
  name_translate: string | null;
  description_translate: string | null;
  order_visible: number;
  parentOptionName: string;
  created: moment.Moment;
  modified: moment.Moment;
  permissions: any[];
}

export interface IMenuOptionModel {
  id?: number;
  menu: IMenuModel;
  menu_id:number
  option: IOptionModel;
  option_id: number;
  is_enabled: boolean;
  start_date: moment.Moment;
  end_date: moment.Moment | null;
  created: moment.Moment;
  modified: moment.Moment;
}

export interface IMenuOptionUpdateModel {
  id?: number;
  menu_id: number;
  option_id: number;
  is_enabled: boolean;
  start_date: string;
  end_date: string | null;
}


export interface IResultMenuOptionModel {
  count: number;
  next: string;
  previous: string;
  results: IMenuOptionModel[];
}

export class MenuOptionModel {
  id?: number;
  menu: IMenuModel;
  menu_id: number;
  option: IOptionModel;
  option_id: number;
  isEnabled: boolean;
  startDate: moment.Moment;
  endDate: moment.Moment | null;
  created: moment.Moment;
  modified: moment.Moment;

  constructor() {
    this.isEnabled = true;
    this.startDate = moment();
    this.endDate = null;
  }

  static fromObject(menuOption: IMenuOptionModel): MenuOptionModel {
    let obj = new MenuOptionModel();
    obj.id = menuOption.id;
    obj.menu = menuOption.menu;
    obj.menu_id = menuOption.menu_id;
    obj.option = menuOption.option;
    obj.option_id = menuOption.option_id
    obj.isEnabled = menuOption.is_enabled;
    obj.startDate = moment(menuOption.start_date);
    obj.endDate = menuOption.end_date ? moment(menuOption.end_date) : null;
    obj.created = moment(menuOption.created);
    obj.modified = moment(menuOption.modified);
    return obj;
  }

  static fromObjectArray(menuOptions: IMenuOptionModel[]): MenuOptionModel[] {
    return menuOptions.map(MenuOptionModel.fromObject);
  }
}

export class ResultMenuOptionModel {
  count: number = 0;
  next: string;
  previous: string;
  results: MenuOptionModel[] = [];

  constructor() {
    this.count = 0;
  }

  static fromObject(result: IResultMenuOptionModel): ResultMenuOptionModel {
    let obj = new ResultMenuOptionModel();
    obj.count = result.count | 0;
    obj.next = result.next;
    obj.previous = result.previous;
    obj.results = (result.results && result.results.length > 0) ? MenuOptionModel.fromObjectArray(result.results) : [];
    return obj;
  }
}
